export type ExportType =
  | "answers"
  | "authorizations"
  | "posts"
  | "questions"
  | "users";

export interface ExportRequestBody {
  fields: string[];
  roles?: number[];
  [key: string]: string | string[] | number | number[] | undefined;
}

export type ExportProgressStage = "submitting" | "processing" | "downloading";

export interface ExportProgressUpdate {
  stage: ExportProgressStage;
  message: string;
}

export interface RunExportOptions {
  onProgress?: (update: ExportProgressUpdate) => void;
}

export type ExportResultStatus = "pending" | "processing" | "completed" | "failed";

export interface ExportResultResponse {
  status?: ExportResultStatus;
  file_url?: string;
  download_url?: string;
  url?: string;
  file?: string;
}

export const EXPORT_ENDPOINTS: Record<ExportType, string> = {
  answers: "/admin/export/answers/",
  authorizations: "/admin/export/authoriztions/",
  posts: "/admin/export/posts/",
  questions: "/admin/export/questions/",
  users: "/admin/export/users/",
};

export const EXPORT_FIELD_OPTIONS: Record<ExportType, string[]> = {
  posts: ["user", "id", "post_text", "status"],
  authorizations: [
    "id",
    "verification_status",
    "authorize_user_role",
    "first_name",
    "last_name",
    "province",
    "city",
    "education_grade",
    "national_code",
    "school_name",
    "teaching_grade",
  ],
  users: ["inviter", "full_name", "username", "email", "phone_number", "role"],
  questions: [
    "education_level",
    "education_grade",
    "book",
    "study_field",
    "content",
    "answered_status",
    "publish_status",
  ],
  answers: ["question", "parent", "content", "publish_status"],
};
